export default function (state = null, action) {
    switch (action.type) {
      case 'SELECTED_ACTIVE_PROJECT':
          return {
            activeProject: action.payload
          };
          break;

      default:
          return {
            activeProject: {},
          }
          break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/services/activeProject/reducer.js